// ##### 25-02-05 Komarov
import React from 'react';
// ##### 25-05-21 Komarov
import NoSearchResultMessageEnd from './NoSearchResultMessageEnd';
import NoSearchResultMessageStart from './NoSearchResultMessageStart';
// ##### 25-05-10 Komarov
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
import useValidateQuery from '../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const NoSearchResult = ({ noTextMessage }) => {
  // ##### Komarov 2025-08-05
  const PleaseInputCityorHotelName = useLocalizedText('PleaseInputCityorHotelName');
  const StartDate = useLocalizedText('StartDate');
  const EndDate = useLocalizedText('EndDate');
  const Adults = useLocalizedText('Adults');
  const Children = useLocalizedText('Children');
  const Rooms = useLocalizedText('Rooms');
  const SelectedCurrency = useLocalizedText('SelectedCurrency');
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();

  return (
    <>
      { /* ##### Komarov 2025-07-21 */}
      <NoSearchResultMessageStart noTextMessage={noTextMessage} />
      <div>
        {PleaseInputCityorHotelName}: {search_data?.title}
      </div>
      <div>
        {StartDate}: {search_data?.start}
      </div>
      <div>
        {EndDate}: {search_data?.end}
      </div>
      <div>
        {Adults}: {search_data?.adults}
      </div>
      <div>
        {Children}: {search_data?.children}
      </div>
      <div>
        {Rooms}: {search_data?.rooms}
      </div>
      <div>
        {SelectedCurrency}: {search_data?.selected_currency}
      </div>
      <NoSearchResultMessageEnd noTextMessage={noTextMessage} />
    </>
  );
};

// ##### 25-05-21 Komarov
export default NoSearchResult;
